<template>
    <!-- この商品をチェックした方はこんな商品もおすすめです！-->
    <div v-if="getLengthObj(pt310Init.relationList) > 0" class="pt310" id="pt310" v-cloak>
        <div class="itemTitle">
            <h3>{{$t('pt300.labels.checkedMsg[0]')}}</h3>
        </div>
        <div class="sliderProductList">
            <Carousel :perPageCustom="perPageCustom" :autoplay="true" :navigationEnabled="false" :loop="true" :autoplayTimeout="4000">
                <slide class="sliderProduct" v-for="(item, index) in pt310Init.relationList" :key="index">
                    <router-link :to="{ name: SiteConstants.PG030 , params: {pageNo: 3, sItemNo: item.M_ITEM_CD}}" @click.native="reload">
                        <!-- 関連商品 -->
                        <img class="sliderProductImg" :src="item.IMG_URL1" @error="getErrImage" :alt="$t('pt300.labels.productOrther')">
                    </router-link>
                    <router-link :to="{ name: SiteConstants.PG030, params: {pageNo: 3, sItemNo: item.M_ITEM_CD}}" @click.native="reload">
                        <span class="sliderProductNm">{{item.WEB_ITEM_NM}}</span>
                    </router-link>
                </slide>
            </Carousel>
        </div><!-- /.history-inner -->
    </div><!-- /.history mb32 -->
</template>
<script>
import axios from "assets/js/request";
import common from "assets/js/common";
import SiteConstants from 'assets/const/SiteConstants.json';
import { Carousel, Slide } from 'vue-carousel';
import { mapMutations } from 'vuex';

export default {
    name: "PT310OtherParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    components:{
        Carousel,
        Slide
    },
    data() {
        return {
            EC_IMG_ICONS: 'icons/',
            pt310Init:{
                relationList:[]
            },
            pt310ReqModel:{

            },
            SiteConstants: SiteConstants,
            site: "",
            perPageCustom: [
                [500,7],
                [0,4]
            ]
        }
    },
    watch: {
        pt310Init: {
            handler(value) {
                this.syncPt310InitState(value);
            },
            deep: true,
            immediate: true,
        },
        pt310ReqModel: {
            handler(value) {
                this.syncPt310ReqModelState(value);
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt310Init = _this.ptInitData;
            _this.perPageCustom[0] = [500,_this.pt310Init.pcNum];
            _this.perPageCustom[1] = [0,_this.pt310Init.spNum];
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT310 + _this.$UrlConstants.DO_INIT, _this.pt310ReqModel).then(function(response) {
                //set data init
                _this.pt310Init = response.data;
                _this.perPageCustom[0] = [500,_this.pt310Init.pcNum];
                _this.perPageCustom[1] = [0,_this.pt310Init.spNum];
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    methods: {
        ...mapMutations('pt310', {
            commitSetPt310Init: 'SET_PT310_INIT',
            commitSetPt310ReqModel: 'SET_PT310_REQ_MODEL'
        }),
        syncPt310InitState(payload) {
            this.commitSetPt310Init(Object.assign({}, payload));
        },
        syncPt310ReqModelState(payload) {
            this.commitSetPt310ReqModel(Object.assign({}, payload));
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        /*
        * format price
        */
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /*
        * goto pg030
        */
        gotoPg030: function(sItemNo){
            this.$router.push({ name: this.SiteConstants.PG030, params :{pageNo: 3, sItemNo: sItemNo}});
        },
        /*
        * Get length obj
        */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        /**
         * Reload page
         */
        reload: function() {
            window.location.reload();
        },
    },
    created(){
        var _this = this;
        const pt310StoreState = _this.$store && _this.$store.state && _this.$store.state.pt310
            ? _this.$store.state.pt310
            : null;

        if (pt310StoreState) {
            if (pt310StoreState.pt310Init && Object.keys(pt310StoreState.pt310Init).length > 0) {
                _this.pt310Init = Object.assign({}, _this.pt310Init, pt310StoreState.pt310Init);
            }
            if (pt310StoreState.pt310ReqModel && Object.keys(pt310StoreState.pt310ReqModel).length > 0) {
                _this.pt310ReqModel = Object.assign({}, _this.pt310ReqModel, pt310StoreState.pt310ReqModel);
            }
        }

        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = _this.$route.query;

        if(Object.keys(paramData).length > 0){
            _this.pt310ReqModel = Object.assign({}, _this.pt310ReqModel, paramData);
        }

        if(Object.keys(queryData).length > 0){
            _this.pt310ReqModel = Object.assign({}, _this.pt310ReqModel, queryData);
        }
    },
}
</script>
